import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Card = function Card(_ref) {
  var children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    href = _ref.href;
  var TagName = href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(TagName, {
    className: cn('wrap', {
      link: href
    }, ["color__".concat(color), "size__".concat(size)]),
    href: href,
    "data-t-id": "ConnectionBlock-Card"
  }, children);
};